import React from 'react';
import { useI18n } from 'react-simple-i18n';
import { getLocaledString } from '../appstate';

export default function RightsView() {
	const { t } = useI18n();

	return (
		<div className={'w-full flex flex-col'}>
			<div
				className={
					'text-4xl w-full text-center text-primary-500 relative z-10 mb-4 md:mb-0 px-6 select-none font-bold'
				}
				style={{ marginTop: '-3.5vh' }}
				id={'ddt'}
			>
				– {getLocaledString('Pravice', 'Rights')} –
			</div>
			<div className={'w-full h-8'} />
			<div
				className={
					'max-w-8xl px-6 md:px-12 mx-auto relative text-lg mt-8 w-full'
				}
				style={{ height: 'calc(100vh - 445px)' }}
			>
				<div
					className={'text-lg w-full bg-white p-4 rounded'}
					dangerouslySetInnerHTML={{
						__html: t('rights.body').split('\n').join('<br />'),
					}}
				/>
			</div>
		</div>
	);
}
